import { ErrorFallback, ErrorFallbackProps } from '~/components/Error';

export const HomeDropShopErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps) => {
  switch (error.message) {
    case 'EMPTY':
      return null;
    default:
      return <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />;
  }
};
